<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>

  <mat-horizontal-stepper #stepper style="background: transparent">
    <mat-step style="height: auto; padding: 5px;" label="Inventera" [completed]="step > 0">
      <div class="row">
        <div class="col">
          <t4-container title="Inventering OneWay" height="500px">
            <div style="text-align: center">
              <p>Såhär gör du:</p>
              <h1>Steg 1</h1>
              <p>Börja med att gå ut på gårdsplan och skriv ner vagnsnummren på de släp som står där. Det är viktigt att du räknar dem som står där fysisk då det händer att kunder tar ett annat släp än de fått nycket till.</p>
              <h1>Steg 2</h1>
              <p>Kom sedan tillbaka hit och fyll i de inventerade vagnsnummren i fältet här bredvid. Ett nummer per rad. Du får direkt återkoppling på om du skrivit ett gilltigt nummer.</p>
              <h1>Steg 3</h1>
              <p>När du är färdig får du en lista med avvikelser, släp som inte står där de förväntats. Ta en extra titt på dessa så att du skrivit rätt nummer och bekräfta sedan.</p>
              <p>Därefter löser vi resten! Tack för hjälpen!</p>
            </div>
          </t4-container>
        </div>
        <div class="col-auto">
          <t4-container title="Resultat" height="500px">
            <div class="row">
              <div class="col-auto iconColumn">
                <ng-container *ngFor="let item of trailers">
                  <mat-icon *ngIf="item.isValid === true" style="color: #1e9b38">thumb_up_alt</mat-icon>
                  <mat-icon *ngIf="item.isValid === false" style="color: #e52a16">thumb_down_alt</mat-icon>
                  <mat-icon *ngIf="item.isLoading">update</mat-icon>
                </ng-container>
              </div>
              <div class="col">
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-label>Vagnsnummer, ett per rad</mat-label>
                  <textarea matInput [(ngModel)]="input" rows="17" cdkAutosizeMinRows="17" cdkAutosizeMaxRows="30" (keyup)="inputChanged()"></textarea>
                </mat-form-field>
              </div>
              <div class="col-auto notesColumn">
                <ng-container *ngFor="let item of trailers">
                  <div *ngIf="item.isValid === true || item.isLoading" style="color: #1e9b38">&nbsp;</div>
                  <div *ngIf="item.isValid === false" style="color: #e52a16">Ogilltigt vagnsnummer</div>
                </ng-container>
              </div>
            </div>
          </t4-container>
        </div>
      </div>
    </mat-step>
    <mat-step style="height: auto; padding: 5px;" label="Bekräfta" [completed]="step > 1">
      <p style="text-align: center; margin: 25px;" *ngIf="found.length > 0 || notFound.length > 0">Följande avvikelser hittades. Stämmer detta?</p>
      <p style="text-align: center; margin: 25px;" *ngIf="found.length == 0 && notFound.length == 0">Inga avvikelser hittades. Allt är i sin ordning.</p>
      <div>
        <t4-container title="Upphittade släp" *ngIf="found">
          <div class="row">
            <div class="col-6"><b>Släp</b></div>
            <div class="col-6"><b>Förväntad plats</b></div>
          </div>
          <ng-container *ngFor="let row of found">
            <div class="row">
              <div class="col-6">{{ row.RentalObject.Alias }} ({{ row.RentalObject.Title }})</div>
              <div class="col-6">{{ row.SystemLocation.Name }} ({{ row.SystemLocation.City }})</div>
            </div>
          </ng-container>
        </t4-container>

        <t4-container title="Saknade släp" *ngIf="notFound">
          <div class="row">
            <div class="col-6"><b>Släp</b></div>
            <div class="col-6"><b>Förväntad plats</b></div>
          </div>
          <ng-container *ngFor="let row of notFound">
            <div class="row">
              <div class="col-6">{{ row.RentalObject.Alias }} ({{ row.RentalObject.Title }})</div>
              <div class="col-6">{{ row.SystemLocation.Name }} ({{ row.SystemLocation.City }})</div>
            </div>
          </ng-container>
        </t4-container>
      </div>
    </mat-step>
    <mat-step style="height: auto; padding: 5px;" label="Klar!">
      <h2>Er inventering har registrerats!</h2>
      <p>Vi kommer nu gå igenom alla avvikelser manuellt och korrigera er vagnpark. Det tar vanligtvis inte mer än 24 timmar.</p>
      <p>Tack för hjälpen!</p>
      <p><b>/ OneWay-teamet</b></p>
    </mat-step>
  </mat-horizontal-stepper>
  <div class="loader" *ngIf="loading.dialog">
    <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
    <mat-progress-spinner mode="indeterminate" style="width: 100px; bottom: 0px; height: 100px; left: calc(50% - 50px); top: calc(50% - 125px)" *ngIf="loading.dialog"></mat-progress-spinner>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button style="margin: 5px; float: left;" (click)="back()" *ngIf="step == 1">Ändra</button>
  <button mat-raised-button color="primary" style="margin: 5px;" *ngIf="step == 0" (click)="next()" [disabled]="!isValid()">Nästa</button>
  <button mat-raised-button color="primary" style="margin: 5px;" *ngIf="step == 1" (click)="next()">Bekräfta</button>
  <button mat-raised-button color="primary" style="margin: 5px;" *ngIf="step == 2" [mat-dialog-close]>Avsluta</button>
</mat-dialog-actions>

